import React from 'react'

export default function Clipboard() {
  return (
    <svg width="23" height="29" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" d="M1.322 22.33V5.453h20.174v22.643H7.044" />
        <path fill="#DEF1D9" d="M1 5.273h21.091v4.585H1z" />
        <path
          d="M7.705 13.204h8.045M6.858 13.204H6.01M7.705 15.335h8.045M6.858 15.335H6.01M7.705 17.467h8.045M6.858 17.467H6.01"
          stroke="#636466"
          strokeWidth="1.6"
        />
        <path fill="#FFF" d="M1.322 22.346H7.16v5.75z" />
        <path
          stroke="#636466"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1.322 22.33V5.453h20.174v22.643H7.044"
        />
        <path fill="#DEF1D9" d="M1.322 22.346H7.16v5.75z" />
        <path
          stroke="#636466"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1.322 22.346H7.16v5.75z"
        />
        <path
          d="M8.83 3.515v.8H4.636a.2.2 0 0 0-.2.2v3.273c0 .11.09.2.2.2h13.819a.2.2 0 0 0 .2-.2V4.515a.2.2 0 0 0-.2-.2H14.26v-.8a2.715 2.715 0 0 0-5.43 0z"
          stroke="#636466"
          strokeWidth="1.6"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}
